module.exports = __webpack_public_path__ + "img/nav-map.e13568dd.svg";